import {
  ComponentDto,
  CreateOnsiteInjectionDto,
  OnsiteEditDto,
} from "@intelligems/ig-types";
import { EmbeddedMod } from "@src/store/slices/experienceBuilder/types";
import { getModHandler } from "@src/store/slices/experienceBuilder/common/utils/modHandlerRegistry";

export const fromMods = (mods: EmbeddedMod[]) => {
  const result = {
    onsiteEdits: [] as OnsiteEditDto[],
    onsiteInjections: [] as CreateOnsiteInjectionDto[],
    components: [] as ComponentDto[],
  };

  for (const mod of mods) {
    const conversion = getModHandler(mod).convertFrom(mod);
    switch (conversion.type) {
      case "onsiteEdit":
        result.onsiteEdits.push(conversion.dto);
        break;
      case "onsiteInjection":
        result.onsiteInjections.push(conversion.dto);
        break;
      case "component":
        result.components.push(conversion.dto);
        break;
    }
  }

  return result;
};
